import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'changedByNameSplitting'
})
export class ChangedByNameSplittingPipe implements PipeTransform {
    transform(changedBy: string) {
        const changedBySplitted = changedBy?.split(' ')[0];
        if (changedBySplitted === 'Microsoft.VisualStudio.Services.TFS') {
            return 'DevOps';
        }
        return changedBySplitted;
    }
}
